import { logout as clearAuthState } from '../authSlice';
import { apiSlice } from '../../../app/api/apiSlice';
import { clearAvatarCache } from '../../../app/api/indexDB';
import { reset } from '../../Gift/giftSlice';
import { resetPostNews } from '../../Gnn/gnnSlice';

export const clearAuth = async (dispatch) => {
  // Dispatch all actions needed to clear state
  dispatch(clearAuthState());

  // Optionally invalidate all API caches
  dispatch(apiSlice.util.resetApiState());

  dispatch(reset({ all: true }));
  dispatch(resetPostNews());
  
  clearAvatarCache();
  // Clear cookies if necessary
  document.cookie = 'refreshToken=; Max-Age=0; path=/; secure; HttpOnly;';
};
